import { ReturnTotals } from "@redotech/redo-model/return-totals-calculator";
import { ReturnItemParams } from "../../util";

interface UseConfirmationSummaryParams {
  totals: ReturnTotals;
  products: ReturnItemParams[] | undefined;
}

interface UseConfirmationSummaryResponse {
  isLoading: boolean;
  productSubtotals: { title: string; total: number }[];
}

export const useConfirmationSummary = ({
  totals,
  products,
}: UseConfirmationSummaryParams): UseConfirmationSummaryResponse => {
  function getTitle(product: ReturnItemParams | undefined): string {
    if (!product?.subtitle || product?.subtitle == "Default Title") {
      return product?.title || "";
    }
    return product?.title + " - " + product?.subtitle;
  }

  const productSubtotals =
    products?.map((product) => {
      return {
        title: getTitle(product),
        total:
          +(product.itemValue ?? product.price) *
          product.quantity *
          (product.exchangeRate ?? 1),
      };
    }) ?? [];

  return { isLoading: !products, productSubtotals };
};
